export default {
  Dot: '.',
  Comma: ',',
}
